interface AuthFieldContainerProps {
  children: React.ReactNode;
}

export const AuthFieldContainer = ({ children }: AuthFieldContainerProps) => {
  return (
    <div className="flex flex-wrap flex-1 items-start gap-5">{children}</div>
  );
};
